const getUpsUiConfig = () => {
    const {REACT_APP_PROD_URL, REACT_APP_LEGACY_PROD_URL, REACT_APP_PS_PROD_URL} = process.env
    const envRegex = {
        local: /^https?:\/\/localhost:3000/,
        localAlternate: /^https?:\/\/localhost:3001/,
        dev: /^https?:\/\/[^/]+-dev[^/]+\/?/,
        qa: /^https?:\/\/[^/]+-qa[^/]+\/?/,
        staging: /^https?:\/\/[^/]+-staging[^/]+\/?/
    }
    if (REACT_APP_PROD_URL) envRegex.prod = new RegExp(`^https?://(www\\.)?${REACT_APP_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)
    if (REACT_APP_LEGACY_PROD_URL) envRegex.legacyProd = new RegExp(`^https?://(www\\.)?${REACT_APP_LEGACY_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)
    if (REACT_APP_PS_PROD_URL) envRegex.psProd = new RegExp(`^https?://(www\\.)?${REACT_APP_PS_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)

    const url = window.location.href

    const findKey = (obj, predicate = o => o) => Object.keys(obj)
        .find(key => predicate(obj[key], key, obj))

    let environment = findKey(envRegex, env => env.test(url)) || 'dev'
    if (environment === 'legacyProd' || environment === 'psProd') environment = 'prod'

    return {
        local: 'https://ups-ui-dev.connectedfleet.io',
        localAlternate: 'https://ups-ui-dev.connectedfleet.io',
        dev: 'https://ups-ui-dev.connectedfleet.io',
        qa: 'https://ups-ui-dev.connectedfleet.io',
        staging: 'https://ups-ui-staging.connectedfleet.io'
    }[environment] || 'https://ups-ui.platform.fleethealth.io'
}

module.exports = {getUpsUiConfig}
